import type { WorkflowRun } from '@heidi/agents/contracts';

/** Stamp a visit-guidance card onto the in-flight session routine when possible. */
export function resolveSurfaceRunAttribution(
  runs: Array<
    Pick<
      WorkflowRun,
      'source_workflow_id' | 'agent_run_id' | 'status' | 'created_at' | 'updated_at'
    >
  >
): { sourceWorkflowId: string | null; agentRunId: string | null } {
  if (runs.length === 0) {
    return { sourceWorkflowId: null, agentRunId: null };
  }

  const scored = [...runs].sort((a, b) => {
    const runningDelta = Number(b.status === 'running') - Number(a.status === 'running');
    if (runningDelta !== 0) return runningDelta;
    const bTime = Date.parse(b.updated_at ?? b.created_at ?? '') || 0;
    const aTime = Date.parse(a.updated_at ?? a.created_at ?? '') || 0;
    return bTime - aTime;
  });

  const run = scored[0];
  if (!run) return { sourceWorkflowId: null, agentRunId: null };
  return {
    sourceWorkflowId: run.source_workflow_id,
    agentRunId: run.agent_run_id ?? null,
  };
}
